import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

type PageHeaderProps = {
  breadcrumb: Crumb[];
  kicker: string;
  title: string;
  description: string;
  meta?: ReactNode;
};

export default function PageHeader({ breadcrumb, kicker, title, description, meta }: PageHeaderProps) {
  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-6 md:py-10">
        <Breadcrumb items={breadcrumb} />
        <div className="mt-4 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-5 h-[3px] rounded-full bg-primary-500"></span>
              <span className="text-[11px] md:text-xs font-medium tracking-[0.16em] uppercase text-primary-600">
                {kicker}
              </span>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">{title}</h1>
            <p className="mt-2.5 text-sm md:text-[15px] text-foreground-600 leading-relaxed">{description}</p>
          </div>
          {meta && <div className="shrink-0">{meta}</div>}
        </div>
      </div>
    </section>
  );
}